export enum Lang {
  viVN = "vi-VN",
  enUs = "en-US",
}
